import { i18n } from 'utils/api/Languages/useLanguages'
import * as Yup from 'yup'
const getMessage =
  (ruleName: any, count?: number) =>
  (params: any): string =>
    i18n.t(ruleName, { count }).replace('$path', params.label || i18n.t('app.validations.this_field'))

Yup.setLocale({
  mixed: {
    default: getMessage('app.validations.default'),
    required: getMessage('app.validations.required'),
    oneOf: (params) => getMessage('app.validations.oneOf')(params).replace('$values', String(params.values)),
    notOneOf: (params) => getMessage('app.validations.notOneOf')(params).replace('$values', String(params.values)),
    notType: getMessage('app.validations.not_type'),
  },
  string: {
    length: (params) =>
      getMessage('app.validations.length', params.length)(params).replace('$length', String(params.length)),
    min: (params) => getMessage('app.validations.minStr', params.min)(params).replace('$min', String(params.min)),
    max: (params) => getMessage('app.validations.maxStr', params.max)(params).replace('$max', String(params.max)),
    matches: (params) => getMessage('app.validations.matches')(params).replace('$regex', String(params.regex)),
    email: getMessage('app.validations.email'),
    url: getMessage('app.validations.url'),
    trim: getMessage('app.validations.trim'),
    lowercase: getMessage('app.validations.lowercase'),
    uppercase: getMessage('app.validations.uppercase'),
  },
  number: {
    min: (params) => getMessage('app.validations.minNum')(params).replace('$min', String(params.min)),
    max: (params) => getMessage('app.validations.maxNum')(params).replace('$max', String(params.max)),
    lessThan: (params) => getMessage('app.validations.lessThan')(params).replace('$less', String(params.less)),
    moreThan: (params) => getMessage('app.validations.moreThan')(params).replace('$more', String(params.more)),
    positive: getMessage('app.validations.positive'),
    negative: getMessage('app.validations.negative'),
    integer: getMessage('app.validations.integer'),
  },
  date: {
    min: (params) => getMessage('app.validations.minDate')(params).replace('$min', String(params.min)),
    max: (params) => getMessage('app.validations.maxDate')(params).replace('$max', String(params.max)),
  },
  object: {
    noUnknown: getMessage('app.validations.noUnknown'),
  },
  array: {
    min: (params) => getMessage('app.validations.minArr')(params).replace('$min', String(params.min)),
    max: (params) => getMessage('app.validations.maxArr')(params).replace('$max', String(params.max)),
  },
})
